import { BattleManager } from "./../BattleManager";
import { GameConstants } from "./../../../GameConstants";
import { GUI } from "./GUI";
import { GameVars } from "../../../GameVars";
import * as Creepts from "endless-siege-engine";

export class TurretSelected extends Phaser.GameObjects.Container {

    private base: Phaser.GameObjects.Image;
    private canon: Phaser.GameObjects.Image;

    private gui: GUI;

    private turretType: string;
    private offY: number;
    private prevWorldY: number;

    constructor(scene: Phaser.Scene, type: string, gui: GUI) {

        super(scene);

        this.prevWorldY = 0;

        if (this.scene.sys.game.device.os.desktop) {
            this.offY = 0;
        } else {
            this.offY = -30;
        }

        let base_name: string;
        let canon_name: string;

        this.turretType = type;
        this.gui = gui;

        let range = GameConstants.CELLS_SIZE;
        let canonY = -20;
        let canonR = 0;

        switch (type) {

            case Creepts.GameConstants.TURRET_PROJECTILE:
                base_name = "archer_1_base";
                canon_name = "archer_1_top";
                canonY = -30;
                range *= 2.5;
                canonR = Math.PI * (3 / 2);
                break;
            case Creepts.GameConstants.TURRET_LASER:
                base_name = "fire_1_base";
                canon_name = "fire_01";
                canonY = -55;
                range *= 3.05;
                break;
            case Creepts.GameConstants.TURRET_LAUNCH:
                base_name = "cannon_1_base";
                canon_name = "cannon_1_top_19";
                canonY = -30;
                range *= 2.5;
                break;
            case Creepts.GameConstants.TURRET_GLUE:
                base_name = "crystal_1_base";
                canon_name = "crystal_1_top_01";
                range *= 1.5;
                break;
            default:
        }

        this.base = new Phaser.GameObjects.Image(this.scene, 0, -20, "texture_atlas_1", base_name);
        this.add(this.base);

        if (canon_name) {
            this.canon = new Phaser.GameObjects.Image(this.scene, 0, canonY, "texture_atlas_1", canon_name);
            this.canon.rotation = canonR;
            this.add(this.canon);
        }

        const rangeCircle = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "shoot_range");
        rangeCircle.setScale((range * 2) / rangeCircle.width);
        this.add(rangeCircle);

        this.scene.sys.updateList.add(this);

        this.scene.input.on("pointerup", (pointer: Phaser.Input.Pointer) => { this.onPointerUp(pointer); }, this);
        this.scene.input.on("pointerdown", (pointer: Phaser.Input.Pointer) => { this.onPointerMove(pointer); }, this);
        this.scene.input.on("pointermove", (pointer: Phaser.Input.Pointer) => { this.onPointerMove(pointer); }, this);
        
        GameVars.turretSelectedOn = true;
    }

    public preUpdate(time: number, delta: number): void {

        if (!this.scene.input.activePointer.isDown && GameVars.turretSelectedOn) {
            this.onPointerUp(this.scene.input.activePointer);
        }
    }

    private onPointerMove(pointer: Phaser.Input.Pointer): void {

        if (!this.scene.sys.game.device.os.desktop) {
            if (this.prevWorldY > GameConstants.GAME_HEIGHT / 4 && pointer.worldY <= GameConstants.GAME_HEIGHT / 4) {
                this.offY = -60;
            } else if (this.prevWorldY < GameConstants.GAME_HEIGHT * (3 / 4) && pointer.worldY >= GameConstants.GAME_HEIGHT * (3 / 4)) {
                this.offY = 60;
            }
        }

        this.setPosition(pointer.x, (pointer.y + this.offY - GameConstants.GAME_HEIGHT) / GameVars.scaleY);
        this.prevWorldY = pointer.worldY;

        const posX = (pointer.x - GameConstants.GAME_WIDTH / 2) / GameVars.scaleCorrectionFactor + ((GameVars.currentMapData.size.c * GameConstants.CELLS_SIZE) / 2);
        const posY = ((pointer.y + this.offY) - GameConstants.GAME_HEIGHT / 2 + GameConstants.CELLS_SIZE / 2) / (GameVars.scaleCorrectionFactor * GameVars.scaleY) + ((GameVars.currentMapData.size.r * GameConstants.CELLS_SIZE) / 2);

        const c = Math.floor(posX / GameConstants.CELLS_SIZE);
        const r = Math.floor(posY / GameConstants.CELLS_SIZE);

        BattleManager.setTurretPrePosition(c, r);
    }

    private onPointerUp(pointer: Phaser.Input.Pointer): void {

        const posX = (pointer.x - GameConstants.GAME_WIDTH / 2) / GameVars.scaleCorrectionFactor + ((GameVars.currentMapData.size.c * GameConstants.CELLS_SIZE) / 2);
        const posY = ((pointer.y + this.offY) - GameConstants.GAME_HEIGHT / 2 + GameConstants.CELLS_SIZE / 2) / (GameVars.scaleCorrectionFactor * GameVars.scaleY) + ((GameVars.currentMapData.size.r * GameConstants.CELLS_SIZE) / 2);

        const c = Math.floor(posX / GameConstants.CELLS_SIZE);
        const r = Math.floor(posY / GameConstants.CELLS_SIZE);

        BattleManager.addTurretToScene(this.turretType, {r: r, c: c});
        
        this.scene.input.removeAllListeners();
        this.gui.removeTurret();

        GameVars.turretSelectedOn = false;
    }
}
